import m from 'mithril';
import './MapDialog.css';
import MapComponent from './MapComponent.js';
import { HotelDetail } from '../../../Models';
import { SvgIcon } from '../../common/MaterialDesignComponents';

interface Attrs {
    hotelDetails : HotelDetail,
    onClose: () => void;
}

export default function MapDialog(): m.Component<Attrs> {
    let dialogElem: any | null = null; 
    return {
        oncreate(vnode) {
            dialogElem = vnode.dom as any;
            dialogElem.addEventListener('close', (event) => {
                vnode.attrs.onClose();
            });
            dialogElem.addEventListener('click', function (event) {                
                let rect = event.target.getBoundingClientRect();
                if (rect.left > event.clientX ||
                    rect.right < event.clientX ||
                    rect.top > event.clientY ||
                    rect.bottom < event.clientY
                ) {
                    dialogElem.close();
                    vnode.attrs.onClose();
                } 
            });
            dialogElem.showModal();
        },
        onupdate(vnode) {
            dialogElem.showModal();           
        },
        view(vnode) {
            const {hotelDetails, onClose} = vnode.attrs;
            return m("dialog.container.map-lightbox-modal", [                
                        m("div.map-lightbox-modal-content", 
                            [
                                m("div.row.p-2",
                                    m("div.col",
                                        m("div.p", hotelDetails.name.en)
                                    ),
                                    m("div.col.text-right",{
                                        onclick: function () {
                                            dialogElem.close();
                                            onClose();
                                        }
                                    },
                                        m(SvgIcon, {
                                            iconType:'close',
                                            colorScheme:'primary'
                                        }),
                                    )
                                ),
                                m(MapComponent,{
                                    hotel: hotelDetails                        
                                })
                        ]
                        )                
            ]);
        }
    }
}